export default {
  // Версия берётся из package.json на этапе сборки (DefinePlugin, vue.config.js) —
  // руками не обновлять. Fallback на случай запуска вне webpack (не должен случаться).
  version: process.env.VUE_APP_VERSION || '0.0.0',
  forceUpdate: false
};
